module.exports = __webpack_public_path__ + "static/media/icon-loc.469c3b1e.svg";